import { useParams } from "react-router-dom";
import useSWR from "swr";
import { fetcher } from "../../../../services/fetcher";
import {
  explorePlansApi,
  parseComparisonsListResponse,
} from "../../services/explorePlansApi";
import SharedPlanDetail from "../../components/SharedPlanDetail/SharedPlanDetail";

const ExplorePlanView = () => {
  const { id } = useParams();
  const { data, isLoading, error } = useSWR(explorePlansApi.detail(id), fetcher, {
    revalidateOnFocus: false,
  });
  const {
    data: itineraryDays,
    isLoading: itineraryLoading,
    error: itineraryError,
  } = useSWR(explorePlansApi.itineraryList(id), fetcher, {
    revalidateOnFocus: false,
  });
  const {
    data: comparisonRowsRaw,
    isLoading: comparisonsLoading,
    error: comparisonsError,
  } = useSWR(explorePlansApi.comparisonsList(id), fetcher, {
    revalidateOnFocus: false,
  });

  const viewData = data
    ? {
        ...data,
        itinerary_days: Array.isArray(itineraryDays) ? itineraryDays : data?.itinerary_days,
        comparison_rows: parseComparisonsListResponse(comparisonRowsRaw),
      }
    : data;

  return (
    <SharedPlanDetail
      data={viewData}
      isLoading={isLoading || itineraryLoading || comparisonsLoading}
      error={error || itineraryError || comparisonsError}
    />
  );
};

export default ExplorePlanView;